// plugins is a alias. see client/build/webpack.base.conf.js
// import http client
import { http } from '@/plugins/http/index';
import { getData } from '@/utils/get';

export const validateLoginKeyForEvent = (payload = null) => http.post('apiMobileLandingPage/validateLoginKeyForEvent', payload).then(getData);
